import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'

// Components
import CategoriesSearch from './CategoriesSearch'
import AdminCategoriesForm from './AdminCategoriesForm'

class AdminCategoriesEdit extends Component {
    render() {
        return (
            <div>
                <h1>Edit Category</h1>

                <Switch>
                    <Route path={'/admin/categories/edit'} exact component={CategoriesSearch} />
                    <Route path={'/admin/categories/edit/:id'} component={AdminCategoriesForm} />
                </Switch>
            </div>
        )
    }
}

export default AdminCategoriesEdit



// WEBPACK FOOTER //
// ./src/components/admin/categories/AdminCategoriesEdit.js